import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { BoltOutlined, EventAvailableOutlined } from '@mui/icons-material';

import { ProductSaleType } from '@apis/product';
import { getProductSaleTypeMeta } from '@utils/productLabels';

const iconSx = {
  fontSize: 16,
  flex: '0 0 auto',
} as const;

const InlineMetaDisplay = ({
  icon,
  label,
  color,
}: {
  icon: ReactNode;
  label: string;
  color: string;
}) => (
  <Stack
    component="span"
    direction="row"
    spacing={0.75}
    alignItems="center"
    sx={{ color, minWidth: 0 }}
  >
    {icon}
    <Typography
      component="span"
      variant="body2"
      sx={{
        color: 'inherit',
        fontWeight: 800,
        lineHeight: 1.25,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Typography>
  </Stack>
);

export const getProductSaleTypeDisplayMeta = (
  saleType?: ProductSaleType | string | null,
) => {
  const meta = getProductSaleTypeMeta(saleType);

  switch (saleType) {
    case ProductSaleType.RESERVATION:
      return {
        label: meta.label,
        color: 'secondary.main',
        icon: <EventAvailableOutlined sx={iconSx} />,
      };
    case ProductSaleType.REAL_TIME:
      return {
        label: meta.label,
        color: 'info.main',
        icon: <BoltOutlined sx={iconSx} />,
      };
    default:
      return {
        label: meta.label,
        color: 'text.secondary',
        icon: null,
      };
  }
};

export const ProductSaleTypeDisplay = ({
  saleType,
}: {
  saleType?: ProductSaleType | string | null;
}) => {
  const meta = getProductSaleTypeDisplayMeta(saleType);

  return (
    <InlineMetaDisplay
      icon={meta.icon}
      label={meta.label}
      color={meta.color}
    />
  );
};
